<template>
  <div class="ListPanel">
    <HeaderSection 
      :title="title"
      :closeLinkTo="{ name: 'home' }">
      <p>
        Op zoek naar inspirerende verhalen? Neem een kijkje in de lijst en laat je inspireren door de voorbeelden en ervaringen van voorgangers.
      </p>
    </HeaderSection>

    <List 
      :items="items" 
      :sortingBy="sortingBy" 
      type="project"
      readmore="zoom" />

  </div>
</template>

<script>
import List from '@/components/lists/List';
import HeaderSection from '@/components/section/HeaderSection';

export default {
  name: 'ListProjects',
  components: {
    List,
    HeaderSection
  },
  data() {
    return {
      title: 'VERHALEN',
      sortingBy: [
        { 
          key: 'name',
          label : 'A-Z'
        },
        {
          key: 'gemeente',
          label: 'Gemeente'
        },
        {
          key: 'thema',
          label: 'Thema'
        }
      ]
    }
  },
  computed: {
    items() {
      let projects = this.$store.getters.getProjectList;

      projects.forEach((project) => {
        project.to = { name: 'project-beknopt', params: { slug: project.slug } };
        return project;
      });

      return projects;
    }
  }
}
</script>

<style lang="scss">

  .ListPanel {
    height: 100%;
    display: flex;
    flex-direction: column;

    .List {
      width: 100%;
      flex-grow: 1;
    }
  }

</style>
